import { select, takeEvery } from 'redux-saga/effects';
import appHistory from "../../app/appHistory";
import { PUSH_GTM_EVENT_START } from "./googleTagManagerConstants";
import { googleTagManageRequiredParamsSelector } from "./googleTagManagerSelectors";
import { pushGtmEvent } from "./googleTagManagerUtils";

export function* pushGtmEventSaga({payload}) {
    const requiredParams = yield select(googleTagManageRequiredParamsSelector);
    const location = appHistory.location;
    const path = `${location.pathname}${location.search}`;
    pushGtmEvent({...requiredParams, path, ...payload});
}

export function* googleTagManagerSagas() {
    yield takeEvery(PUSH_GTM_EVENT_START, pushGtmEventSaga);
}